import Vue from 'vue'
import firebase from '@/firebase/firebase'
import _misc from '@/assets/utils/misc.js'

const db = firebase.firestore()
let refNotifications = null;

function handleNotificationSnapshot (state, commit, change) {
    if(change.type === "added") {
        const notification = change.doc.data()
        const index = change.doc.id
        const foundNtf = state.notificationsMsg.findIndex(a => a.id == change.doc.id)
        if(foundNtf == -1)
            commit('setNewMessage', {
                id       : change.doc.id,
                index    : index,
                title    : notification.title,
                msg      : notification.msg,
                time     : notification.createdAt.toDate(),
                icon     : notification.icon,
                color    : notification.color,
                read     : notification.read,
                is       : notification.is,
                payload  : notification.hasOwnProperty('payload') ? notification.payload : null
            })
    }
}

export default {
    namespaced : true,

    state : {
        notificationsMsg : []
    },

    getters : {
        unreadNtfMsg (state) {
            return state.notificationsMsg.filter(a => a.read == false)
        },

        sortedNftMsg (state) {
            const obj = [...state.notificationsMsg]
            return obj.sort((a,b) => b.time - a.time)
        }
    },

    actions : {
        async fetchNotifications ({ state, rootGetters, commit }) {
            const companyId  = rootGetters.getCompanyID
            const userId     = rootGetters.getUserStoredData.uid
            refNotifications = db.collection(`/company/${companyId}/companyUsers/${userId}/notifications`)
            const stickyNtfSnap = refNotifications
                                .where('sticky', '==', true)
                .onSnapshot(snapshot => {
                    snapshot.docChanges().forEach(change => {
                        handleNotificationSnapshot(state, commit, change)
                    });
                });
            const ntfSnap = refNotifications
                                .where('createdAt', '>=', Vue.moment().subtract(2, 'hours').toDate())
                                .where('sticky', '==', false)
                                .where('read', '==', false)
                .onSnapshot(snapshot => {
                    snapshot.docChanges().forEach(change => {
                        handleNotificationSnapshot(state, commit, change)
                    });
                })
        },

        async readAllMsg ({state, commit, rootGetters}) {
            const unreadNtfs = rootGetters['notifications/unreadNtfMsg']
            if(!refNotifications) return
            try {
                let batch = firebase.firestore().batch()
                unreadNtfs.forEach(ntf => {
                    const refDoc = refNotifications.doc(ntf.id)
                    batch.update(refDoc, { read : true }, { merge : true })
                })
                await batch.commit()
                commit('setAllMsgRead')
            } catch (err) {
                console.log('Erro ao definir como lido: ', err.message) 
            }
        },

        async setPushToken ({rootGetters}, token) {
            const companyId  = rootGetters.getCompanyID
            const userId     = rootGetters.getUserStoredData.uid
            const userSnap   = db.collection(`/company/${companyId}/companyUsers/`).doc(userId)
            await userSnap.update({ pushToken : token }, { merge : true })
        }
    },

    mutations : {
        setAllMsgRead (state) {
            state.notificationsMsg.forEach(ntf => Vue.set(ntf, 'read', true))
        },

        setNewMessage (state, notificationObj) {
            state.notificationsMsg.push(notificationObj)
        },

        cleanUpNotifications (state) {
            state.notificationsMsg = []
        }
    }
}